import Vue from "vue";
import App from "./App.vue";
import Vuex from "vuex";
import store from "./store/store";
import vuetify from "./plugins/vuetify";
import VueRouter from "vue-router";
import "./assets/css/tailwind.css";
import "@/assets/css/utilities.scss";
import "@/assets/css/vuetify-overrides.scss";
import router from "./router";
import moment from "moment";
import "./plugins/base";
import VueConfetti from "vue-confetti";
import VueApexCharts from "vue-apexcharts";
import configureAxios from "./config/axiosConfig";
import configureOneSignal, {
  oneSignalCordovaInit,
} from "./config/oneSignalConfig";

// Localize moment
moment.locale("nl");

// Authentication
import auth from "@websanova/vue-auth/dist/v2/vue-auth.esm.js";
import { DRIVERS, OPTIONS } from "./auth/authconfig";

// Filters and Validation
import "./filters/filters";
import "./config/validationConfig";
import "./config/configuration";

// Register Plugins
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(VueConfetti);
Vue.use(VueApexCharts);

// Configure Axios
configureAxios(Vue);

// Configure Vue Auth
Vue.use(auth, {
  plugins: { http: Vue.axios, router },
  drivers: DRIVERS,
  options: OPTIONS,
});

// Register Components Globally
Vue.component("apexchart", VueApexCharts);

Vue.config.productionTip = false;

function createVueInstance() {
  new Vue({
    store,
    vuetify,
    router,
    render: (h) => h(App),
    beforeMount() {
      if (process.env.NODE_ENV === "production") {
        configureOneSignal(this);
      }
    },
  }).$mount("#app");
}

// Initialize App
if (process.env.NODE_ENV === "production") {
  createVueInstance();
  document.addEventListener("deviceready", oneSignalCordovaInit, false);
} else {
  createVueInstance();
}
